export default __webpack_public_path__ + "static/media/246.d753a7c4.jpg";